import { AssetHeader } from "@/features/assets/assetParts";
import { NfcBanner, QuickLinks } from "@/features/dashboard/components/QuickLinks";

export default function IdentityAssetsPage() {
  return (
    <div data-testid="identity-assets-page" className="mw-rise space-y-8">
      <AssetHeader eyebrow="Identity Assets" title="Your identity assets." description="Everything generated from your one professional identity." />
      <QuickLinks />
      <NfcBanner />
    </div>
  );
}
